import { Sparkles, PenLine } from "lucide-react";
import {
  CheckCircle2,
  Briefcase,
  Scissors,
  RefreshCw,
  Lightbulb,
} from "lucide-react";

export const ACTIONS = [
  {
    id: "fix_grammar",
    label: "Fix Grammar",
    short: "Grammar",
    description: "Correct spelling, punctuation, and typos",
    icon: CheckCircle2,
    accent: "emerald",
    dot: "#059669",
    bg: "bg-emerald-50",
    ring: "ring-emerald-200",
    text: "text-emerald-700",
  },
  {
    id: "simplify",
    label: "Make Easier to Understand",
    short: "Simplify",
    description: "Replace jargon with plain language",
    icon: Sparkles,
    accent: "amber",
    dot: "#D97706",
    bg: "bg-amber-50",
    ring: "ring-amber-200",
    text: "text-amber-700",
  },
  {
    id: "professional",
    label: "Make Professional",
    short: "Professional",
    description: "Polished tone for emails & work",
    icon: Briefcase,
    accent: "blue",
    dot: "#2563EB",
    bg: "bg-blue-50",
    ring: "ring-blue-200",
    text: "text-blue-700",
  },
  {
    id: "shorten",
    label: "Shorten Text",
    short: "Shorten",
    description: "Trim fluff, keep the point",
    icon: Scissors,
    accent: "indigo",
    dot: "#4F46E5",
    bg: "bg-indigo-50",
    ring: "ring-indigo-200",
    text: "text-indigo-700",
  },
  {
    id: "rewrite",
    label: "Complete Rewrite",
    short: "Rewrite",
    description: "Fresh phrasing, better flow",
    icon: RefreshCw,
    accent: "purple",
    dot: "#7C3AED",
    bg: "bg-violet-50",
    ring: "ring-violet-200",
    text: "text-violet-700",
  },
  {
    id: "generate_ideas",
    label: "Generate Ideas",
    short: "Ideas",
    description: "Brainstorm angles & directions",
    icon: Lightbulb,
    accent: "rose",
    dot: "#E11D48",
    bg: "bg-rose-50",
    ring: "ring-rose-200",
    text: "text-rose-700",
  },
];

export const SAMPLES = [
  "hey i wanted to let you know that the meeting is moved to 4pm tommorow, please confirm if that time works for u",
  "The comprehensive utilization of synergistic methodologies facilitates the optimization of stakeholder engagement paradigms across cross-functional teams.",
  "im writing to apply for the marketing intern position i saw on your website i think i would be a good fit because i love marketing and social media and i have done some projects",
];

export function actionLabel(id) {
  return ACTIONS.find((a) => a.id === id)?.short || id;
}
